/* eslint-disable */ 
import _ from 'lodash'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { divisionRankingFilter } from '../../../utils/functions';
import { DIVISIONS,RankingsHeaders } from '../../../utils/constants';
import Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getSeasonsRanking, getRankingsBySeason, getRankingWeeksDDBySeason, getRankingELBySeasonWeek } from '../api'
import { exportCSV, tableOptions} from '../common'

export default class RankingsPage extends Component {
 
  constructor(props) {
    super(props);
    this.state = {
      seasons:[],
      rankingsAll:[],
      womenDivRanking:[],
      rankingWeeks:[],
      rankingEventLinks:[],
      seasonId:1,
      currentSeason:'',
      currentSeasonText: '',
      currentWeekText: '',
      currentSeasonId: 1,
      thruweek: 1,
      thruweekText : '',      
      weekNo: 1,
      activeDivision: 'MEN'
    };
    this.handleActiveSeasonChange = this.handleActiveSeasonChange.bind(this)
    this.handleActiveSeasonWeekChange = this.handleActiveSeasonWeekChange.bind(this)
    this.handleTabSelect = this.handleTabSelect.bind(this)
  }
  
  componentWillMount() {
  }

  componentDidMount (){
    const _this = this
    getSeasonsRanking().then(function(response) {
      const seasons = response.data 
     _this.setState({ currentSeason:response.data[0].seasonName })  
     _this.setState({seasonId:seasons[0].seasonId})

     getRankingWeeksDDBySeason(seasons[0].seasonId).then(function(response){
          const rankingWeeks = response.data
          _this.setState({ rankingWeeks:rankingWeeks })   
          _this.setState({thruweekText:'thru '+rankingWeeks[0].thruDate})
          _this.setState({weekNo: rankingWeeks[0].weekNo})
          getRankingsBySeason(seasons[0].seasonId,_this.state.weekNo).then(function(response){
            _this.setState({ rankingsAll: response.data })   
          }) 

          getRankingELBySeasonWeek(seasons[0].seasonId,rankingWeeks[0].weekNo).then(function(response){
            _this.setState({rankingEventLinks:response.data})
          })

      });

     _this.setState({ seasons:seasons }) 
   })
  } 

  setActiveSeasonsOptions()
    {
      const { seasons } = this.state
      const option = seasons.map((season) => {
        return(<option value={season.seasonId} key={season.seasonId}>{season.seasonName}</option>)
      })
      return option
    } 

  setActiveWeeksOptions() {
      const { rankingWeeks } = this.state
      const option =rankingWeeks.map((rankingWeek) => {
        return(<option value={rankingWeek.weekNo} key={rankingWeek.weekNo}>{rankingWeek.weekNoText}</option>)
      })
      return option
  } 

  handleActiveSeasonChange(event){
      const _this = this
      const seasonId = event.target.value 
      const selectedSeason = _.find(this.state.seasons,['seasonId',parseInt(seasonId)])
      const selectedWeekNo = 1//_this.state.weekNo
    
      _this.setState({currentSeason:selectedSeason.seasonName}) 
      _this.setState({seasonId:seasonId})
      getRankingsBySeason(seasonId,selectedWeekNo).then(function(response){
        _this.setState({ rankingsAll: response.data });
          getRankingWeeksDDBySeason(seasonId).then(function(response){
            const rankingWeeks = response.data
            _this.setState({ rankingWeeks:rankingWeeks })   
            _this.setState({thruweekText:'thru '+rankingWeeks[rankingWeeks.length-1].thruDate}) 
            _this.setState({weekNo:rankingWeeks[rankingWeeks.length-1].weekNo})
          })
    })
    getRankingELBySeasonWeek(seasonId,selectedWeekNo).then(function(response){
        _this.setState({ rankingEventLinks: response.data })
    })
  }

  handleActiveSeasonWeekChange(event){
    const _this = this
    const weekNo = event.target.value 
    const thruDate = _(_this.state.rankingWeeks)
                      .filter(r => r.weekNo == weekNo)
                      .map('thruDate')
                      .value();
    _this.setState({weekNo:weekNo})                  

    getRankingsBySeason(_this.state.seasonId,weekNo).then(function(response){
      _this.setState({ rankingsAll: response.data });
      _this.setState({thruweekText:'thru '+thruDate}) 
    })

    getRankingELBySeasonWeek(_this.state.seasonId,weekNo).then(function(response){
      _this.setState({ rankingEventLinks: response.data })
    })
  }

  handleTabSelect = (key) => {
    this.setState({ activeDivision: key === 1 ? 'MEN' : 'WOMEN' });
  };

  renderEventLinks(){
     const _this = this
    if (!_this.state.rankingEventLinks) {
      return null;
    }

    return (
        <div className="rankingLeftColumn_">
          {
              _this.state.rankingEventLinks.map(function(eventLink) {
                return <Link to={`/eventPowerPoints/${eventLink.seasonId}/${eventLink.eventId}/${eventLink.eventAbbrev}/${_this.state.currentSeason}/${_this.state.activeDivision}`}>{eventLink.eventAbbrev}<br/></Link>
              })
          }
        </div>
    );
  }

  teamNameFormatter(cell, row, props ) {
    return <Link to={`/teamPowerPoints/${row.seasonId}/${row.teamId}/${row.weekNo}/${row.teamName}/${row.division}`}>{cell}</Link>;      
  }  
   
  rankingLegend() {
    return  <Row >
                <Col xs={3} />
                <Col xs={6}  className="totals_background legend_background">
                  <b>EVENT</b> -  # of events counted /  <b>Tr1</b> - # of  tierevents / <b>AVG</b> 
                  - avg. power points per event<br/>
                  <b>AxEF</b> - AVG multiplied by Event Factor (7.00) / <b>PPx2</b> - power points multiplied by two<br/> 
                  <b>Total</b> - AxEF plus PPx2<br/>
                  <br/>
                  <b>Prv</b> - prior power ranking / <b>Diff</b> - change in  power ranking / <b>+/-</b> -- change in TOTAL<br/>
                </Col>
            </Row>
  }

  render() {    
    const _this = this
    const rankingsAll=_this.state.rankingsAll 
    const menDivRanking = rankingsAll.filter( (dataItem) => divisionRankingFilter(dataItem, DIVISIONS.MENDIVISION));
    const womenDivRanking = rankingsAll.filter( (dataItem) => divisionRankingFilter(dataItem, DIVISIONS.WOMENDIVISION));
 
    return (
        <div>  
          <Navwrapper />
          <div className="container-fluid">
            <Row>
              <div className="pageHeading" >
                  {/* {this.renderArchiveDropDown()} */}
                  <div className="archiveDropDown">
                      <div >
                        <div className="titleWrap">
                          <label className="archiveLabel">Past Season: </label>
                        </div>
                        <div className="valueWrap" >
                            <select onChange={this.handleActiveSeasonChange}>
                              {this.setActiveSeasonsOptions()}
                            </select>
                        </div>
                      </div>
                  </div>
                  <h4>{this.state.currentSeason}</h4>
                    <h4 >
                      Online Team Ranking System <br/>
                    </h4>
                    <h4>                   
                      <div className="weeksDropDown">
                        <div >
                          <div className="titleWrap">
                            <label> {this.state.thruweekText}</label>&nbsp;&nbsp;
                            &nbsp;&nbsp;                        
                            <label className="archiveLabel">Week: </label>                                    
                          </div>
                          <div className="valueWrap" >
                              <select onChange={this.handleActiveSeasonWeekChange} value={_this.state.weekNo}>
                                {this.setActiveWeeksOptions()}
                              </select>
                          </div>
                        </div>
                      </div> 
                    </h4>
              </div>
            </Row>      
            <Row>          
              <Col xs={2}  >
                {this.renderEventLinks()}
              </Col>            
                  <Col xs={10} >                           
                    <div className="rankingRightColumn_"> 
                      <Tabs
                        activeKey={this.state.activeDivision === 'MEN' ? 1 : 2}
                        onSelect={this.handleTabSelect}
                        id="team-ranking-results-tabs">
                          <Tab eventKey={1} title="MEN">                                          
                              <BootstrapTable 
                                data={menDivRanking} 
                                striped 
                                hover 
                                options={tableOptions}
                                pagination               
                              >
                                  <TableHeaderColumn          
                                    dataField="Id" 
                                    isKey 
                                    dataAlign="right" 
                                    dataSort 
                                    data-Visible="false"               
                                    hidden                 
                                  >ID
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="rankingNo" dataSort width="2%" >R#
                                  </TableHeaderColumn>
                                  <TableHeaderColumn 
                                    dataField="teamName" 
                                    dataSort  
                                    dataFormat={this.teamNameFormatter} 
                                    formatExtraData={this.props} 
                                    width="15%" 
                                  >TEAM NAME
                                  </TableHeaderColumn>   
                                  <TableHeaderColumn dataField="evt" dataAlign="right"  width="2%" >Evt
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="tr1" dataAlign="right"  width="2%" >Tr1
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="axEF" dataAlign="right"  width="2%" >AxEF
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="pPx2" dataAlign="right"  width="2%" >PPx2
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="prv" dataAlign="right"  width="2%" >Prv
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="diff" dataAlign="right"  width="2%" >Diff
                                  </TableHeaderColumn>
                                  <TableHeaderColumn dataField="plusMin" dataAlign="right"  width="2%" >+/-
                                  </TableHeaderColumn>                    
                              </BootstrapTable>                                                             
                              { exportCSV(menDivRanking,RankingsHeaders,'Ranking-Men.csv')}
                          </Tab>
                          <Tab eventKey={2} title="WOMEN">
                          <BootstrapTable 
                            data={womenDivRanking} 
                            striped 
                            hover 
                            options={tableOptions} 
                            pagination 
                          >
                            <TableHeaderColumn          
                              dataField="Id" 
                              isKey 
                              dataAlign="right" 
                              dataSort 
                              data-Visible="false"               
                              hidden                 
                            >ID
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="rankingNo" dataSort width="2%" >R#
                            </TableHeaderColumn>
                            <TableHeaderColumn 
                              dataField="teamName" 
                              dataSort  
                              dataFormat={this.teamNameFormatter} 
                              formatExtraData={this.props} 
                              width="15%" 
                            >TEAM NAME
                            </TableHeaderColumn>    
                            <TableHeaderColumn dataField="evt" dataAlign="right"  width="2%" >Evt
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="tr1" dataAlign="right"  width="2%" >Tr1
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="axEF" dataAlign="right"  width="2%" >AxEF
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="pPx2" dataAlign="right"  width="2%" >PPx2
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="prv" dataAlign="right"  width="2%" >Prv
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="diff" dataAlign="right"  width="2%" >Diff
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="plusMin" dataAlign="right"  width="2%" >+/-
                            </TableHeaderColumn>                                       
                          </BootstrapTable>
                              { exportCSV(womenDivRanking,RankingsHeaders,'Ranking-Women.csv')}
                        </Tab>
                                {this.rankingLegend()}
                      </Tabs>
                    </div>
                  </Col>
            </Row>
          </div>
          <Footer />
        </div>
      );  
  }
  
}


// WEBPACK FOOTER //
// ./src/components/pages/rankings/index.js